// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1FxhO","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2XIur","obliqueLine":"membershipbadge_obliqueLine___fxYo"};